import { useEffect } from 'react';

import { reduxConnect } from '../../common';
import { processFavoritesFromDirective} from '../../common/actions/favoriteLocationActions';

const mapStoreStateToProps = () => {
    return {};
};

const mapDispatchToProps = {
    processFavoritesFromDirective
};

 // Transfers to Redux any new favorites activity in the directive.
export const FavoriteLocationBridge = reduxConnect(mapStoreStateToProps, mapDispatchToProps)(({
    favorites,
    processFavoritesFromDirective
    

}) => { 
    useEffect(()=> { 
        if (favorites) {
            processFavoritesFromDirective(favorites);
        }
    }, [favorites]);

    return null;
});